import React, { Component } from "react";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import Switch from "react-switch";
import axios from "axios";
import Moment from "moment";
import MicroModal from "micromodal";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import latinize from "latinize";
import Select from "react-select";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";

import {
  ShowVisibleDetailsAtd,
  SearchingHistoryData,
  DetailsAnotationsida,
  DetailsMarkstarida,
  InsertAnotations,
  DetailsFileShared,
  DownloadFile,
  dbfileSize,
  InteracoesContactNumber,
  changeActiveHeader,
  getContacts,
  GetInteractionsModal,
  GetDetailsContacts,
  GetContacts,
  ConnectionsAPI,
  GetCompanysV2,
  getContactsV2,
  EditInfoCli,
  InsertCompanyContact,
  AddNumberContact,
  GetPhoneMidia,
} from "../../actions";

import JPG from "../../build/images/jpg-file.png";
import XLS from "../../build/images/media-icon.png";
import PDF from "../../build/images/pdf-file.png";
import MP3 from "../../build/images/mp3-file.png";
import Highlighter from "react-highlight-words";
import AVI from "../../build/images/avi-file.png";
import WHATSAPP from "../../build/images/t-whatsapp.svg";
import WEBCHAT from "../../build/images/t-webchat.svg";
import ICONPDFEXPORT from "../../build/images/pdf.svg";
import PdfDocument from "../../components/templates/PdfDocument";
import VIDEO from "../../build/images/video.jpg";
import AUDIO from "../../build/images/audio.svg";
import FOTO from "../../build/images/foto.svg";
import DOC from "../../build/images/doc.svg";
import MIDIAZAP from "../../build/images/whatsapp_new.svg";
import MIDIAFACE from "../../build/images/facebook_new.svg";
import MIDIAWEB from "../../build/images/webchat-new.svg";
import MIDIAEMAIL from "../../build/images/email-new.svg";
import INSTAGRAM from "../../build/images/instagram_new.svg";
import TELEGRAM from "../../build/images/telegram-new.svg";
import GOOGLEGBM from "../../build/images/googlegbm-new.svg";
import TWITTER from "../../build/images/twitter-new.svg";
import LINKEDIN from "../../build/images/linkedin-new.svg";
import TEAMS from "../../build/images/channels/teamsMedium.svg";
import { ReactComponent as SMSICON } from "../../build/images/sms-new.svg";

import { ReactComponent as IconDoc } from "../../build/images/attendanceIcons/document-text.svg";
import { ReactComponent as ArrowDown } from "../../build/images/arrow_down.svg";
import { ReactComponent as IconEdit } from "../../build/images/attendanceIcons/edit-2.svg";
import { ReactComponent as IconAdd } from "../../build/images/attendanceIcons/user-add.svg";
import { ReactComponent as IconLink } from "../../build/images/attendanceIcons/user-tag.svg";

import InteractionsModal from "../../modals/InteractionsModal";
import Typography from "../../components/Typography";
import ModalsDetails from "../../components/modals/NewModals";
import AnotationModal from "../../components/modals/AnotationModal";
import FieldContainer from "../../components/FieldContainer/FieldContainer";
import NpsDetailsCopy from "../NpsDetailsCopy/NpsDetailsCopy";
import Search from "../NpsDetailsCopy/Search/Search";

import "../../build/css/details.css";

import { Tooltippy } from "../../actions/Tippy";

const { meses } = require("../../services/data");
const { connection_platform } = require("../../services/api");

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;
var checkreply = false;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  // if(parseInt(connection_platform.port_apache_view_extern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

port = localStorage.getItem('port');
pathname = localStorage.getItem('pathname');

MicroModal.init();

function createJSON(item) {
  if (item) {
    var mensagem_tratada = item.replace(/¿/gi, "\n");
    mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    let valor = 1;
    try {
      mensagem_tratada =
        '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
    } catch (e) {
      mensagem_tratada = item;
    }
    return mensagem_tratada;
  }
}

function tratarMSG(item) {
  var mensagem_tratada = item;
  mensagem_tratada = item.replace(/¿/gi, "\n");
  mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
  let valor = 1;
  try {
    mensagem_tratada =
      '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
    var obj = JSON.parse(mensagem_tratada);
    mensagem_tratada = obj[1][0].mensagem_tratada;
  } catch (e) {
    mensagem_tratada = item;
    mensagem_tratada = mensagem_tratada.replace(/\r\n/gi, "ªª");
    mensagem_tratada = mensagem_tratada.replace(/\r\n/gi, "ªª");
    mensagem_tratada = mensagem_tratada.replace(/"/gi, "");
    mensagem_tratada = mensagem_tratada.replace(
      /[^A-ZÀ-Ú a-zà-ú 0-9 , . ? ! * {2}# ; : '-' _ + § ¿ { } ' " ª \\ \ ]/g,
      ""
    );
    mensagem_tratada =
      '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
    try {
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
      mensagem_tratada = mensagem_tratada.replace(/ªª/gi, "\r\n");
    } catch (e) {
      mensagem_tratada = item;
    }
  }
  return mensagem_tratada;
}

const mapStateToProps = (state) => {
  return {
    History: state.history,
    Contact: state.atendimento,
    IPCurrent: state.ipcurrent,
    DisplayDetails: state.displaydetailsatd,
    DetailsAnotations: state.detailsanotations,
    CriticidadesAnotacoes: state.criticalitys,
    DetailsMarkstar: state.detailsmarkstars,
    DetailsFileShared: state.detailsfileshared,
    InfoUsers: state.informationusers,
    MessagesHeader: state.messagesheader,
    ActiveHeader: state.activeheader,
    Contacts: state.contacts,
    Companys: state.companys,
    DetailsContacts: state.detailscontacts,
  };
};

const mapDispatchToProps = (dispatch) => ({
  SearchingHistory: (histstart, histend, telefone, cdrid, idgroup) => {
    dispatch(
      SearchingHistoryData(histstart, histend, cdrid, telefone, idgroup)
    );
  },
  ShowVisibleDetailsAtdIn: (post) => {
    dispatch(ShowVisibleDetailsAtd(post));
  },
  DetailsAnotationsida: (datainit, datafim, idcriticidade, telefone) => {
    dispatch(DetailsAnotationsida(datainit, datafim, idcriticidade, telefone));
  },
  DetailsMarkstarida: (datainit, datafim, telefone) => {
    dispatch(DetailsMarkstarida(datainit, datafim, telefone));
  },
  DetailsFileSharedIn: (datainit, datafim, formats, midias, telefone) => {
    dispatch(DetailsFileShared(datainit, datafim, formats, midias, telefone));
  },
  InsertAnotationsIn: (idcdr, criticidade, comentario, userid) => {
    InsertAnotations(idcdr, criticidade, comentario, userid)(dispatch);
  },
  DonwloadFileIn: (url, name) => {
    DownloadFile(url, name)(dispatch);
  },
  InteracoesContactNumber: (number, datainit, datafim, mensagem, idgroup) => {
    dispatch(
      InteracoesContactNumber(number, datainit, datafim, mensagem, idgroup)
    );
  },
  changeActiveHeader: (contactid, status) => {
    dispatch(changeActiveHeader(contactid, status));
  },
  SearchingContacts: (post, contatoof, empresa) => {
    dispatch(getContacts(post, contatoof, empresa));
  },
  GetInteractionsModal: (client, number) => {
    dispatch(GetInteractionsModal(client, number));
  },
  GetDetailsContacts: (value, data, datacontact) => {
    dispatch(GetDetailsContacts(value, data, datacontact));
  },
  GetCompanys: (title, page) => {
    dispatch(GetCompanysV2(title, page));
  },
  SearchingContactsV2: (post, contatoof, empresa, page) => {
    dispatch(getContactsV2(post, contatoof, empresa, page));
  },
  EditCli: (id, name, arraymenubot) => {
    dispatch(EditInfoCli(id, name, arraymenubot));
  },
  InsertCompanyContact: (contactid, companyid) => {
    dispatch(InsertCompanyContact(contactid, companyid));
  },
  AddNumberContact: (post, number) => {
    dispatch(AddNumberContact(post, number));
    dispatch(GetPhoneMidia([]));
  },
});

function isJson(item) {
  item = typeof item != "string" ? JSON.stringify(item) : item;

  try {
    item = JSON.parse(item);
  } catch (e) {
    return false;
  }

  if (typeof item === "object" && item != null) {
    return true;
  }

  return false;
}

class DetailsAttendanceNps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalhistory: 0,
      dataatual: "",
      showHistory: false,
      searchText: "",
      arrowterm: 0,
      history: [],
      buttonAnnotations: false,
      buttonFileComptd: false,
      buttonSpotlight: false,
      buttonMap: false,
      buttonHistoric: false,
      DescAnotacoes: [],
      critSelec: "Todos",
      iconCrit: "",
      idCrit: "",
      buttonShowCriticits: false,
      detailsAnotations: [],
      totalAnotations: 0,
      detailsMarkstar: [],
      detailsMarkstar2: [],
      requiredmimetype: [1],
      detailsFileShared: [],
      totalMarkstar: 0,
      totalFiles: 0,
      buttonLearnMore: false,
      expandLearn: [],
      optionsActionsFile: 0,
      buttonShowOptionsAnot: false,
      buttonShowInsertAnot: false,
      SelecCritic: "Selecione",
      SaveSucess: false,
      idCrit2: 0,
      visible: "",
      defaultValueFormat: "Todos",
      defaultValueMidias: "Todos",
      isActive: false,
      imagemodal: "",
      historyRecent: [],
      buttonShowCriticitsIn: false,
      criticidadeSelec: "Defina uma criticidade",
      buttonHeaders: false,
      headerMessage: [],
      checkSendHeader: [],
      typeModal: "",
      linkContact: "",
      saveContact: "",
      errorModal: false,
      directDetails: false,
      viewContacts: false,
      textSearchContacts: "",
      listSearchContacts: [],
    };
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }

  SearchHistory(e, telefone, cdrid) {
    let histstart = this.datahistoryinit.value;
    let histend = this.datahistoryfim.value;
    let idgroup = this.props.InfoUsers.idgroup;
    this.props.SearchingHistory(histstart, histend, telefone, cdrid, idgroup);
    this.setState({
      clientpdf: telefone,
      datapdfend: histend,
      datapdfinit: histend,
      cliente: telefone,
    });
  }

  toggleModal(event, url) {
    this.setState({ isActive: !this.state.isActive });
    this.state.imagemodal = url;
    MicroModal.close("modal__anotacoes-details");
    MicroModal.show("modal__anotacoes-adicionar");
  }

  handleKeyUp(inf) {
    var elems = document.getElementsByTagName("mark");
    var tam = elems.length;

    if (tam >= this.state.arrowterm + 1) {
      elems[this.state.arrowterm].scrollIntoView(false);
      if (inf == "less") {
        if (this.state.arrowterm != 0) {
          this.state.arrowterm = this.state.arrowterm - 1;
        }
      } else {
        this.state.arrowterm = this.state.arrowterm + 1;
      }
    } else {
      if (elems[this.state.arrowterm]) {
        this.state.arrowterm = 0;
        elems[this.state.arrowterm].scrollIntoView(false);
      }
    }
  }

  DisplayFileComptd(e, telefone) {
    e.preventDefault();
    this.setState({ buttonFileComptd: !this.state.buttonFileComptd });
    if (this.state.buttonFileComptd === false) {
      this.buttonSearchFileCompart(e, telefone);
    }
  }

  DisplayAnnotations(e, telefone) {
    e.preventDefault();
    this.setState({ buttonAnnotations: !this.state.buttonAnnotations });
    if (this.state.buttonAnnotations === false) {
      this.buttonSearchAnotation(e, telefone);
    }
  }

  DisplayHeaders(e, telefone) {
    e.preventDefault();
    this.setState({ buttonHeaders: !this.state.buttonHeaders });
  }

  DisplaySpotlight(e, telefone) {
    e.preventDefault();
    this.setState({ buttonSpotlight: !this.state.buttonSpotlight });
    if (this.state.buttonSpotlight === false) {
      this.buttonSearchMarkstar(e, telefone);
    }
  }

  DisplayMap(e) {
    e.preventDefault();
    this.setState({ buttonMap: !this.state.buttonMap });
  }

  DisplayHistoric(e, telefone, cdrid) {
    e.preventDefault();
    const agora = Moment().subtract(7, "days");
    let datainit = agora.format("YYYY-MM-DDT00:00");
    let datafim = Moment().format("YYYY-MM-DDT23:59");
    let today = Moment().format("YYYY-MM-DD");
    let idgroup = this.props.InfoUsers.idgroup;
    this.setState({
      buttonHistoric: !this.state.buttonHistoric,
      dataatual: today,
    });
    if (this.state.buttonAnnotations === false) {
      this.SearchHistory(e, telefone, cdrid);
      this.props.InteracoesContactNumber(
        telefone.substr(2),
        datainit,
        datafim,
        "",
        idgroup
      );
      this.setState({ dateinit: datainit, dateend: datafim });
    }
  }

  DisplayShowOptions(e) {
    e.preventDefault();
    this.setState({ buttonShowOptionsAnot: !this.state.buttonShowOptionsAnot });
  }

  ReturningShowAnot(e) {
    e.preventDefault();
    this.setState({ buttonShowInsertAnot: !this.state.buttonShowInsertAnot });
  }

  DisplayInsertAnotations(e) {
    e.preventDefault();
    this.setState({ buttonShowInsertAnot: !this.state.buttonShowInsertAnot });
  }

  buttonSearchAnotation(e, telefone) {
    e.preventDefault();
    var erro = 0;
    let now = Moment().subtract(1, "month");
    const datainit = now.format("YYYY-MM-DD");
    const datafim = Moment().format("YYYY-MM-DD");
    const idcriticidade = this.state.idCrit;

    let comparation = Moment(datainit).isBefore(datafim);

    if (datainit == "") var erro = 1;

    if (datafim == "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      this.props.DetailsAnotationsida(
        datainit,
        datafim,
        idcriticidade,
        telefone
      );
    }
  }

  buttonSearchFileCompart(e, telefone) {
    e.preventDefault();
    var erro = 0;
    let now = Moment().subtract(1, "month");
    const datainit = now.format("YYYY-MM-DD");
    const datafim = Moment().format("YYYY-MM-DD");
    // const datainit = this.timearqinit.value;
    // const datafim = this.timearqfim.value;
    const formats =
      "3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28";
    // const formats = this.mimetypeids.value;
    const midias = "2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18";
    // const midias = this.midias.value;

    var comparation = Moment(datainit).isBefore(datafim);

    if (datainit == "") var erro = 1;

    if (datafim == "") var erro = 1;

    if (formats == "") var erro = 1;

    if (midias == "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      this.props.DetailsFileSharedIn(
        datainit,
        datafim,
        formats,
        midias,
        telefone
      );
    }
  }

  buttonSearchMarkstar(e, telefone) {
    e.preventDefault();
    var erro = 0;
    // let datainit = this.dataInitMark.value;
    // let datafim = this.dataFimMark.value;

    let now = Moment().subtract(1, "month");
    const datainit = now.format("YYYY-MM-DD");
    const datafim = Moment().format("YYYY-MM-DD");

    var comparation = Moment(datainit).isBefore(datafim);

    if (datainit == "") var erro = 1;

    if (datafim == "") var erro = 1;

    if (comparation === false) {
      var erro = 1;
      if (datainit === datafim) {
        var erro = 0;
      }
    }

    if (erro === 0) {
      this.props.DetailsMarkstarida(datainit, datafim, telefone);
    }
  }

  SearchInHistory(e) {
    e.preventDefault();
    this.setState({ showHistory: !this.state.showHistory });
  }

  ShowCriticitys(e) {
    e.preventDefault();
    this.setState({ buttonShowCriticits: !this.state.buttonShowCriticits });
  }

  ShowCriticitysInsert(e) {
    e.preventDefault();
    this.setState({ buttonShowCriticitsIn: !this.state.buttonShowCriticitsIn });
  }

  ChangeCriticitys(e, desccriticidade, idcriticidade, tipocriticidade) {
    e.preventDefault();
    this.setState({ buttonShowCriticitsIn: !this.state.buttonShowCriticitsIn });
    this.setState({
      criticidadeSelec: desccriticidade,
      iconeCriticidade: tipocriticidade,
      idCriticidadeSelec: idcriticidade,
    });
  }

  SelectCriticitys(e, desccriticidade, idcriticidade, tipocriticidade) {
    this.setState({
      critSelec: desccriticidade,
      iconCrit: tipocriticidade,
      idCrit: idcriticidade,
    });
    this.setState({ buttonShowCriticits: !this.state.buttonShowCriticits });
  }

  SelectCriticitys2(e, desccriticidade, idcriticidade, tipocriticidade) {
    this.setState({ SelecCritic: desccriticidade, idCrit2: idcriticidade });
    this.setState({ buttonShowCriticits: !this.state.buttonShowCriticits });
  }

  ReturnSaveSucess() {
    this.setState({ SaveSucess: !this.state.SaveSucess });
  }

  ShowChoiceFormat(e) {
    e.preventDefault();
    this.setState({ buttonShowFormatsFile: !this.state.buttonShowFormatsFile });
  }

  choiceFormat(event, formats, name) {
    this.mimetypeids.value = formats;
    this.setState({
      buttonShowFormatsFile: !this.state.buttonShowFormatsFile,
      defaultValueFormat: name,
    });
  }

  choiceMidia(event, midias, name) {
    this.midias.value = midias;
    this.setState({
      buttonShowMidias: !this.state.buttonShowMidias,
      defaultValueMidias: name,
    });
  }

  ShowChoiceMidias(e) {
    e.preventDefault();
    this.setState({ buttonShowMidias: !this.state.buttonShowMidias });
  }

  DonwloadFile(e, url, name) {
    e.preventDefault();
    this.props.DonwloadFileIn(url, name);
  }

  SaveAnotation(e, infoatendimento, infouser) {
    var criticidade = this.state.idCrit2;
    var comentario = this.commentAnotat.value;
    var erro = 0;
    var userid = infouser.id;
    var idcdr = infoatendimento.idatendimento;

    if (criticidade === "Selecione") var erro = 1;

    // if(comentario === '')
    //   var erro = 1

    if (userid === "") var erro = 1;

    if (idcdr === "") var erro = 1;

    if (erro === 0) {
      this.setState({ SaveSucess: !this.state.SaveSucess });
      this.props.InsertAnotationsIn(idcdr, criticidade, comentario, userid);
    }

    if (this.state.buttonShowCriticits === true)
      this.setState({ buttonShowCriticits: !this.state.buttonShowCriticits });
  }

  get_filesize(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open("HEAD", url, true);

    xhr.onreadystatechange = function () {
      if (this.readyState == this.DONE) {
        callback = callback(parseInt(xhr.getResponseHeader("Content-Length")));
      }
    };
    xhr.send();
  }

  checkExpandLearn(e, idanot) {
    var checkClick =
      this.state.expandLearn.indexOf(idanot) != -1 ? true : false;

    if (!checkClick) {
      this.setState({
        expandLearn: this.state.expandLearn.concat([idanot]),
      });
    } else {
      this.setState({
        expandLearn: this.state.expandLearn.filter(function (val) {
          return val != idanot;
        }),
      });
    }
  }

  showExpandVisual(e, idarq) {
    this.setState({ optionsActionsFile: idarq });
  }

  ShowVisible() {
    this.props.ShowVisibleDetailsAtdIn(false);
  }

  ShowModals(e, modal, telefone, cdrid, contactName) {
    //Função que seta o nome e o número do contato pros modais
    this.props.GetInteractionsModal(contactName, telefone);
    //
    switch (modal) {
      case "modal__anotacoes-details":
        MicroModal.show("modal__anotacoes-details-new");
        this.buttonSearchAnotation(e, telefone);
        break;
      case "modal__arquivos-compartilhados-details":
        MicroModal.show("modal__arquivos-compartilhados-details");
        this.buttonSearchFileCompart(e, telefone);
        break;
      case "modal__mensagens-favoritas-details":
        MicroModal.show("modal__mensagens-favoritas-details");
        this.buttonSearchMarkstar(e, telefone);
        break;
      case "modal__historico-atendimento-details":
        MicroModal.show("modal__historico-atendimento-details");
        this.SearchHistory(e, telefone, cdrid);
        this.setState({
          clientpdf: telefone,
          datapdfend: Moment().format("YYYY-MM-DDT23:59"),
          datapdfinit: Moment().format("YYYY-MM-DDT00:00"),
          cliente: telefone,
        });
        break;
      case "modal__agenda-pf__cliente__interacoes_history":
        const agora = Moment().subtract(7, "days");
        let datainit = agora.format("YYYY-MM-DDT00:00");
        let datafim = Moment().format("YYYY-MM-DDT23:59");
        let today = Moment().format("YYYY-MM-DD");
        this.setState({ dataatual: today });
        let idgroup = this.props.InfoUsers.idgroup;

        this.props.InteracoesContactNumber(
          telefone.substr(2),
          datainit,
          datafim,
          "",
          idgroup
        );
        MicroModal.show("modal__historico-atendimento-details");
        this.SearchHistory(e, telefone, cdrid);
        this.setState({ dateinit: datainit, dateend: datafim });
        this.setState({
          clientpdf: telefone,
          datapdfend: Moment().format("YYYY-MM-DDT23:59"),
          datapdfinit: Moment().format("YYYY-MM-DDT00:00"),
          cliente: telefone,
        });
        break;
      default:
        break;
    }
  }

  handleScroll = (e) => {
    let element = e.target;
    let elmnt = document.getElementsByClassName("time");
    // for (var i = 0; i < elmnt.length; i++) {
    // }
    // let y = elmnt.scrollTop;

    // if (element.scrollHeight - element.scrollTop === element.clientHeight) {
    //   // do something at end of scroll
    // }
  };

  ShowImage(e) {
    MicroModal.close("modal__historico-atendimento-details");
  }

  VerifierImage(e, urlimage, modal) {
    this.setState({ isOpen: true, urlimage: urlimage });
    if (modal === "history") {
      MicroModal.close("modal__historico-atendimento-details");
    }
    if (modal === "dmark") {
      MicroModal.close("modal__mensagens-favoritas-details");
    }
  }

  CloseImage(e, modal) {
    this.setState({ isOpen: false, urlimage: "" });
    if (modal === "history") {
      MicroModal.show("modal__historico-atendimento-details");
    }
    if (modal === "dmark") {
      MicroModal.show("modal__mensagens-favoritas-details");
    }
  }

  handleAddContact(contact, typeModal) {
    const data = {
      telefone: contact.telefone,
      nome: contact.cliente.trim(),
      codext: "",
      email: "",
    };
    port = localStorage.getItem('port');
    this.setState({ cursorState: true });
    axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/getcontacts?number=${contact.telefone}&nome=&empresa=&contato=&codext=&email=`
      )
      .then((response) => {
        if (response.data.length > 0) {
          this.setState({ saveContact: response.data[0] });

          if (typeModal === "link") {
            MicroModal.show("modal__linkAdd-contact");
            this.setState({ typeModal: "link", directDetails: true });
            this.props.GetDetailsContacts(false, response.data[0]);
          } else {
            this.props.GetDetailsContacts(true, response.data[0]);

            // this.setState({ typeModal: "add" });
            // MicroModal.show("modal__linkAdd-contact");
          }
        } else {
          if (typeModal === "link") {
            MicroModal.show("modal__linkAdd-contact");
            this.setState({ typeModal: "link", directDetails: true });
            this.props.GetDetailsContacts(false, contact);
          } else {
            this.props.GetDetailsContacts(true, "", contact);
            this.props.AddNumberContact("", contact.telefone);
          }
        }
        this.setState({ cursorState: false });
      });
  }

  // switchChange(contactId) {
  //   const clone = [...this.state.checkSendHeader];
  //   const verificar = clone.find((value) => value.label === contactId);

  //   if (verificar) {
  //     verificar.active = !verificar.active;
  //     this.setState({ checkSendHeader: clone });
  //   } else {
  //     let novoObj = { label: contactId, active: false };
  //     this.setState({ checkSendHeader: [...clone, novoObj] });
  //   }
  // }

  async handleSearchContact(data, page) {
    const newData = {
      nome: data ? data : "",
      telefone: "",
      codext: "",
      email: "",
    };

    port = localStorage.getItem('port');

    // bind.props.SearchingContacts(newData, "", "");
    this.setState({ listSearchContacts: [] });
    return await axios
      .get(
        `${
          connection_platform.type_connect
        }://${pathname}:${port}/conn/getcontacts_v3?number=&nome=${
          data ? data : ""
        }&empresa=&contato=&codext=&email=&page=${page}&limit=50`
      )
      .then((response) => {
        if (response.data !== "") {
          this.setState({ listSearchContacts: response.data });
          // return response.data;
        }
      })
      .catch((error) => {
        console.log("LOGINGENIUM ERROR BACKEND: ", error);
      });
  }

  CloseModal(typemodal) {
    this.props.GetDetailsContacts(false, "", "");
    this.setState({
      linkContact: "",
    });
    MicroModal.close("modal__linkAdd-contact");
  }

  async handleSaveContact(
    typemodal,
    contact,
    infousers,
    directDetails,
    detailsContacts
  ) {
    if (!detailsContacts.detailsget && detailsContacts.detailscontacts) {
      if (detailsContacts.detailscontacts.id) {
        await axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/linkcontact?idcontactold=${detailsContacts.detailscontacts.id}&idcontactnew=${this.state.linkContact.id}&idphone=${detailsContacts.detailscontacts.phone_id}`
          )
          .then((response) => {
            if (response.status === 200 && response.data !== "") {
              if (directDetails) {
                const menubotOld = contact.menubot
                  .split("~¿")
                  .find((value) => value.indexOf("DDI_E164") > -1);

                const menubotNew = `Nome na Agenda: ${this.state.linkContact.name}~¿DisplayName: ${this.state.linkContact.displayname}~¿Empresa na Agenda: ${this.state.linkContact.empresa}~¿${menubotOld}~¿`;
                this.props.EditCli(
                  contact.idatendimento,
                  this.state.linkContact.name,
                  menubotNew
                );
                // EditInfoCli(
                //   contact.idatendimento,
                //   this.state.linkContact.name,
                //   menubotNew
                // );
              }
              this.setState({ saveContact: "", directDetails: false });
              this.CloseModal("link");
              return response.data;
            }
          });
      } else {
        axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/insertphone?phonetypeid=3&number=` +
              detailsContacts.detailscontacts.telefone +
              `&iduser=` +
              this.state.linkContact.id
          )
          .then((response) => {
            if (response.data !== "") {
              let data = response.data;
              axios
                .get(
                  `${connection_platform.type_connect}://${pathname}:${port}/conn/insertcontactphone?contactid=` +
                    this.state.linkContact.id +
                    `&phoneid=` +
                    data[0].id
                )
                .then((response) => {
                  if (directDetails) {
                    const menubotOld = contact.menubot
                      .split("~¿")
                      .find((value) => value.indexOf("DDI_E164") > -1);

                    const menubotNew = `Nome na Agenda: ${this.state.linkContact.name}~¿DisplayName: ${this.state.linkContact.displayname}~¿Empresa na Agenda: ${this.state.linkContact.empresa}~¿${menubotOld}~¿`;
                    this.props.EditCli(
                      contact.idatendimento,
                      this.state.linkContact.name,
                      menubotNew
                    );
                  }
                  this.setState({ directDetails: false });
                  this.CloseModal("link");
                  return response.data;
                });
            }
          });
      }
    }
  }

  handleChooseLinkContact(contact) {
    this.setState({
      linkContact: contact,
    });
    this.setState({
      viewContacts: false,
    });
    this.setState({
      listSearchContacts: [],
    });
    this.setState({
      textSearchContacts: "",
    });
  }

  render() {
    const {
      Contact,
      DisplayDetails,
      IPCurrent,
      DetailsAnotations,
      CriticidadesAnotacoes,
      History,
      DetailsMarkstar,
      DetailsFileShared,
      displayscreen,
      monitorclient,
      InfoUsers,
      MessagesHeader,
      ActiveHeader,
      Companys,
      Contacts,
      DetailsContacts,
    } = this.props;
    const { searchText } = this.state;
    const searchWords = searchText.split(/\s/).filter((word) => word);

    var ContactId = Contact;

    this.timedefaultinit = Moment().format("YYYY-MM-DDT00:00");
    this.timedefaultfim = Moment().format("YYYY-MM-DDT23:59");
    this.datatimeinit = Moment().format("YYYY-MM-DD");
    this.datatimefim = Moment().format("YYYY-MM-DD");
    this.timearqinit = Moment().format("YYYY-MM-DD");
    this.timearqfim = Moment().format("YYYY-MM-DD");

    var MenuBot = [];
    var dia = "";
    var mes = "";
    var ano = "";
    var auxdia = "";

    const agora = Moment().subtract(7, "days");
    this.datatimeinit = agora.format("YYYY-MM-DD");
    this.timearqinit = agora.format("YYYY-MM-DD");

    if (DisplayDetails.displaydetailsatd === true)
      this.state.visible = " active";
    if (DisplayDetails.displaydetailsatd === false)
      this.state.visible = " w-50";
    if (DisplayDetails.displaydetailsatd === undefined)
      this.state.visible = " active";

    if (CriticidadesAnotacoes.length != 0) {
      this.state.DescAnotacoes = CriticidadesAnotacoes.criticalitys;
      if (this.state.idCrit2 === 0) {
        this.state.iconeCriticidade =
          this.state.DescAnotacoes[0].class_criticality;
        this.state.SelecCritic = this.state.DescAnotacoes[0].description;
        this.state.idCrit2 = this.state.DescAnotacoes[0].id;
      }
    }

    if (DetailsAnotations.length != 0) {
      this.state.detailsAnotations = DetailsAnotations.detailsanotations;
      this.state.totalAnotations = this.state.detailsAnotations.length;
    } else {
      this.state.detailsAnotations = [];
      this.state.totalAnotations = 0;
    }

    if (DetailsMarkstar.length != 0) {
      this.state.detailsMarkstar = DetailsMarkstar.detailsmarkstars;
      this.state.detailsMarkstar2 = DetailsMarkstar.detailsmarkstars;
      this.state.detailsMarkstar2 = this.state.detailsMarkstar2.filter(
        (details) => this.state.requiredmimetype.includes(details.mimetypeid)
      );
      this.state.totalMarkstar = this.state.detailsMarkstar.length;
    } else {
      this.state.detailsMarkstar = [];
      this.state.detailsMarkstar2 = [];
      this.state.detailsMarkstar2 = [];
      this.state.totalMarkstar = 0;
    }

    if (DetailsFileShared.length != 0) {
      this.state.detailsFileShared = DetailsFileShared.detailsfileshared;
      this.state.totalFiles = this.state.detailsFileShared.length;
    } else {
      this.state.detailsFileShared = [];
      this.state.totalFiles = 0;
    }

    if (displayscreen != "monitoring") {
      if (ContactId.length != 0) {
        if (ContactId.menubot) {
          var MenuBot = ContactId.menubot.split("~¿");
          var verifierName = MenuBot[0].split(":");
          // if(verifierName[0] === "Nome" || verifierName[0] === "NOME"){
          //     MenuBot.shift();
          // }
          MenuBot.forEach((obj, index) => {
            var value = obj.split(":");
            if (value[0] === "DisplayName") {
              MenuBot.splice(index, 1);
            }
            if (value[1] === ContactId.cliente && obj === null) {
              MenuBot.splice(index, 1);
            }
          });
        }
      }
    } else {
      ContactId = monitorclient;
      if (ContactId.length != 0) {
        if (ContactId.menubot) {
          var MenuBot = ContactId.menubot.split("~¿");
          var verifierName = MenuBot[0].split(":");
          if (verifierName[0] === "Nome" || verifierName[0] === "NOME") {
            MenuBot.shift();
          }
          MenuBot.forEach((obj, index) => {
            var value = obj.split(":");
            if (value[0] === "DisplayName") {
              MenuBot.splice(index, 1);
            }
          });
        }
      }
    }

    if (History.lenght != 0) {
      this.state.history = History;
      this.state.historyRecent = History;
      this.state.historyRecent = this.state.historyRecent.filter((history) =>
        this.state.requiredmimetype.includes(history.mimetypeid)
      );
      if (this.state.historyRecent.lenght === 0) {
        this.state.historyRecent = [];
      }
      if (this.state.history[0] != undefined) {
        this.state.totalhistory = this.state.history[0].interacoes;
      }
    } else {
      this.state.history = [];
      this.state.historyRecent = [];
    }

    if (MessagesHeader.length != 0) {
      var HeaderMessage = MessagesHeader[ContactId.telefone];
      // this.setState({ headerMessage: MessagesHeader[ContactId.idatendimento] });
      this.state.headerMessage = MessagesHeader[ContactId.telefone];

      if (
        !Object.keys(this.state.checkSendHeader).includes(
          ContactId.idatendimento
        )
      ) {
        this.state.checkSendHeader = {
          ...this.state.checkSendHeader,
          [ContactId.idatendimento]: false,
        };
      }

      if (HeaderMessage === undefined) {
        HeaderMessage = [];
        delete this.state.checkSendHeader[ContactId.idatendimento];
        // this.setState({ headerMessage: [] });
        this.state.headerMessage = [];
      }
    } else {
      HeaderMessage = [];
      // this.setState({ headerMessage: [] });
      this.state.headerMessage = [];
    }

    let checkedSwitch = true;
    if (ActiveHeader.length != 0) {
      let findChecked = ActiveHeader.find(
        (header) => header.label === ContactId.telefone
      );

      if (findChecked) {
        checkedSwitch = findChecked.active;
      }
    }

    if (this.state.saveContact.number !== ContactId.telefone) {
      this.state.saveContact = "";
    }

    return (
      <>
        <NpsDetailsCopy
          actions={
            <p className="details__info-name">
              <Typography.H4 color={"blue-selected-4"} weight={700}>
                {createJSON(ContactId.cliente)}
              </Typography.H4>
              <div className="icons-addLink">
                <Tooltippy content={"Editar ou adicionar contato"}>
                  <IconEdit
                    onClick={(event) => {
                      this.handleAddContact(ContactId, "add");
                    }}
                  />
                </Tooltippy>

                <Tooltippy content={"Vincular contato"}>
                  <IconLink
                    onClick={() => {
                      this.handleAddContact(ContactId, "link");
                    }}
                  />
                </Tooltippy>
              </div>
            </p>
          }
          details={
            <div
              className={
                "block full-height no-margin-bottom" + this.state.visible
              }
              id="user-details"
            >
              <div className="block-header">
                <div className="details__info">
                  {/* details__info-name */}
                  <></>

                  <ul className="details__info-list">
                    {ContactId.idmidia !== "3" && (
                      <li className="details__info-item">
                        <span className="details__info-label">Telefone:</span>
                        <span className="details__info-text">
                          {ContactId.telefone}
                        </span>
                      </li>
                    )}
                    <li className="details__info-item">
                      <span className="details__info-label">
                        Data do contato:{" "}
                      </span>
                      <span className="details__info-text">
                        {ContactId.datatimeatd}
                      </span>
                    </li>
                    <li className="details__info-item">
                      <span className="details__info-label">Motivo: </span>
                      <span className="details__info-text">
                        {parseInt(ContactId.direction) === 1
                          ? ContactId.nomesubservico
                          : ContactId.servico}
                      </span>
                    </li>
                    {/* {ContactId.idmidia !== "3" && ( */}
                    <li className="details__info-item">
                      <span className="details__info-label">Informações</span>
                      <ul className="details__info-inner-list">
                        {(() => {
                          if (
                            ContactId.protocolo !== null &&
                            ContactId.protocolo !== undefined &&
                            ContactId.protocolo !== ""
                          ) {
                            return (
                              <li className="details__info-inner-item">
                                <span className="details__info-inner-label">
                                  {"Protocolo : "}
                                </span>
                                <span className="details__info-inner-text">
                                  {ContactId.protocolo}
                                </span>
                              </li>
                            );
                          }
                        })()}

                        {(() => {
                          if (
                            ContactId.datatachado != undefined &&
                            ContactId.datatachado !== "" &&
                            ContactId.datatachado !== null
                          ) {
                            if (isJson(ContactId.datatachado) === true) {
                              let strDtch = ContactId.datatachado;
                              return Object.keys(strDtch).map((key) => (
                                <li className="details__info-inner-item">
                                  <span className="details__info-inner-label">
                                    <b>{key + ":"}</b>
                                  </span>
                                  <span className="details__info-inner-text">
                                    {strDtch[key]}
                                  </span>
                                </li>
                              ));
                            }
                          }
                        })()}
                        {/* DDI_E164: 5568992135836 */}
                        {/* Dados não coletados */}

                        {MenuBot.map((bot, index) => {
                          const separator = bot.split(":");

                          if (separator[0]) {
                            return (
                              <li
                                key={index}
                                className="details__info-inner-item"
                              >
                                <span className="details__info-inner-label">
                                  {`${createJSON(separator[0])}: `}
                                </span>
                                {separator[1] ? (
                                  separator[1].length > 21 ? (
                                    <Tooltippy
                                      content={
                                        separator[1].length > 21
                                          ? createJSON(separator[1])
                                          : ""
                                      }
                                    >
                                      <span className="details__info-inner-text">
                                        {separator[1].length > 21
                                          ? `${createJSON(separator[1]).slice(
                                              0,
                                              21
                                            )}
                                ...`
                                          : createJSON(separator[1])}
                                      </span>
                                    </Tooltippy>
                                  ) : (
                                    <span className="details__info-inner-text">
                                      {createJSON(separator[1])}
                                    </span>
                                  )
                                ) : (
                                  ""
                                )}

                                {/* <span className="details__info-inner-text">12345</span> */}
                              </li>
                            );
                          }
                        })}

                        {(() => {
                          if (
                            connection_platform.nc2_integration === true &&
                            connection_platform.nc2_users.indexOf(
                              InfoUsers.ramal
                            ) !== -1
                          ) {
                            if (
                              InfoUsers.infoclinc2.length !== 0 &&
                              ContactId.isDialNc2
                            ) {
                              return InfoUsers.infoclinc2.map((info) => (
                                <li className="details__info-inner-item">
                                  {/* <span className="details__info-icon material-icons">contact_support</span> */}
                                  <span className="details__info-inner-label">
                                    {info}
                                  </span>
                                  {/* <a href={InfoUsers.infoclinc2} title={InfoUsers.infoclinc2}><span className="details__info-text">clique para abrir</span></a> */}
                                </li>
                              ));
                            }
                          }
                        })()}
                      </ul>
                    </li>
                    {/* )} */}
                  </ul>
                </div>
              </div>
              <div className="block-content">
                <div className="block-body">
                  <ul className="details__accordion-list accordion">
                    {this.state.headerMessage.length > 0 &&
                      InfoUsers.variables_integration && (
                        <li className="details__accordion-item details__accordion-anotc accordion-item">
                          <div
                            className={
                              this.state.buttonHeaders
                                ? "details__accordion-top active"
                                : "details__accordion-top"
                            }
                            onClick={(event) =>
                              this.DisplayHeaders(event, ContactId.telefone)
                            }
                          >
                            <Typography.H5
                              color={"blue-selected-4"}
                              weight={700}
                            >
                              Cabeçalho
                            </Typography.H5>
                            <span className="details__accordion-icon">
                              <ArrowDown className={`pausa-btn__icon-svg`} />
                            </span>
                          </div>
                          <div className="details__accordion-item__content">
                            <div
                              className={
                                this.state.buttonHeaders
                                  ? "anotc__recent-content active"
                                  : "anotc__recent-content"
                              }
                            >
                              {(() => {
                                const items =
                                  InfoUsers.variables_integration.split(",");
                                const headers = this.state.headerMessage[0];

                                return (
                                  <div className="details__accordion-item__content-container">
                                    {items.map((item) => {
                                      let label = "";

                                      if (item === "codigo_ticket") {
                                        label = "Número do caso";
                                      } else {
                                        label =
                                          item.substring(0, 1).toUpperCase() +
                                          item.substring(1).toLowerCase();
                                      }

                                      return (
                                        <div
                                          className="details__accordion-item__content-header"
                                          key={item}
                                        >
                                          <Typography.H6 weight={700}>
                                            {label}:
                                          </Typography.H6>
                                          <Typography.H6 weight={400}>
                                            {" "}
                                            {headers
                                              ? headers.header[item]
                                              : ""}{" "}
                                          </Typography.H6>
                                        </div>
                                      );
                                    })}
                                    <Switch
                                      id={"switchCabeçalho"}
                                      checked={checkedSwitch}
                                      onChange={() => {
                                        this.props.changeActiveHeader(
                                          ContactId.telefone,
                                          !checkedSwitch
                                        );
                                        window.localStorage.setItem(
                                          "switchHeader",
                                          !checkedSwitch
                                        );
                                      }}
                                      uncheckedIcon={false}
                                      checkedIcon={false}
                                      onColor={"#b8c1ea"}
                                      onHandleColor={"#455CC7"}
                                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                      width={34}
                                      height={14}
                                      handleDiameter={20}
                                    />
                                  </div>
                                );
                              })()}
                            </div>
                          </div>
                        </li>
                      )}
                    <li className="details__accordion-item accordion-item">
                      <div
                        className={
                          this.state.buttonHistoric
                            ? "details__accordion-top active"
                            : "details__accordion-top"
                        }
                        onClick={(event) =>
                          this.DisplayHistoric(
                            event,
                            ContactId.telefone,
                            ContactId.idatendimento
                          )
                        }
                      >
                        <Typography.H5 color={"blue-selected-4"} weight={700}>
                          Interações
                        </Typography.H5>
                        {/* <p className="details__accordion-label">Interações</p> */}
                        <span className="details__accordion-icon">
                          {/* <i className="material-icons">chevron_right</i> */}
                          <ArrowDown className={`pausa-btn__icon-svg`} />
                        </span>
                      </div>

                      <div
                        className={
                          this.state.buttonHistoric
                            ? "anotc__recent-content active"
                            : "anotc__recent-content"
                        }
                      >
                        {(() => {
                          if (this.state.historyRecent.length != 0) {
                            var cliente = createJSON(ContactId.cliente);
                            var mensagem = createJSON(
                              this.state.historyRecent[0].messagem
                            );
                            var idmidia = this.state.historyRecent[0].idmidia;
                            var data_envio =
                              this.state.historyRecent[0].dataenvio +
                              "-" +
                              this.state.historyRecent[0].horaenvio;
                            var agente = this.state.historyRecent[0].agente;
                            return (
                              <div>
                                <div className="msg-fav__mp-bubble recent">
                                  <div className=" msg-fav__mp-bubble--recent">
                                    {mensagem}
                                  </div>
                                </div>
                                <div className="anotc__mp-result-item-top padding">
                                  <div className="anotc__mp-result-item-info--recent no-padding">
                                    <p className="anotc__mp-result-item-name small">
                                      {cliente}
                                    </p>
                                    {(() => {
                                      if (agente === false) {
                                        return (
                                          <p className="anotc__mp-result-item-title small">
                                            Cliente
                                          </p>
                                        );
                                      } else {
                                        return (
                                          <p className="anotc__mp-result-item-title small">
                                            Atendente
                                          </p>
                                        );
                                      }
                                    })()}
                                  </div>
                                  <div className="anotc__mp-result-item-critic med">
                                    {(() => {
                                      if (idmidia === 5) {
                                        return (
                                          <img
                                            width="15.48"
                                            height="15"
                                            src={MIDIAZAP}
                                            alt=""
                                            className="arq-comp__t-channel__icon"
                                          />
                                        );
                                      } else if (idmidia === 4) {
                                        return (
                                          <img
                                            width="15.48"
                                            height="15"
                                            src={MIDIAFACE}
                                            alt=""
                                            className="arq-comp__t-channel__icon"
                                          />
                                        );
                                      } else if (idmidia === 2) {
                                        return (
                                          <img
                                            width="15.48"
                                            height="15"
                                            src={MIDIAWEB}
                                            alt=""
                                            className="arq-comp__t-channel__icon"
                                          />
                                        );
                                      } else if (idmidia === 3) {
                                        return (
                                          <img
                                            src={MIDIAEMAIL}
                                            width="15.48"
                                            height="15"
                                            alt=""
                                            className="arq-comp__t-channel__icon"
                                          />
                                        );
                                      } else if (idmidia === 6) {
                                        return (
                                          <img
                                            src={INSTAGRAM}
                                            width="15.48"
                                            height="15"
                                            alt=""
                                            className="arq-comp__t-channel__icon"
                                          />
                                        );
                                      } else if (idmidia === 8) {
                                        return (
                                          <img
                                            src={TELEGRAM}
                                            width="15.48"
                                            height="15"
                                            alt=""
                                            className="arq-comp__t-channel__icon"
                                          />
                                        );
                                      } else if (idmidia === 9) {
                                        return (
                                          <img
                                            src={TWITTER}
                                            width="15.48"
                                            height="15"
                                            alt=""
                                            className="arq-comp__t-channel__icon"
                                          />
                                        );
                                      } else if (idmidia === 10) {
                                        return (
                                          <img
                                            src={LINKEDIN}
                                            width="15.48"
                                            height="15"
                                            alt=""
                                            className="arq-comp__t-channel__icon"
                                          />
                                        );
                                      } else if (idmidia === 11) {
                                        return (
                                          <img
                                            src={GOOGLEGBM}
                                            width="15.48"
                                            height="15"
                                            alt=""
                                            className="arq-comp__t-channel__icon"
                                          />
                                        );
                                      } else if (idmidia === 12) {
                                        return <SMSICON />;
                                      } else if (idmidia === 15) {
                                        return (
                                          <img
                                            src={TEAMS}
                                            width="15.48"
                                            height="15"
                                            alt=""
                                            className="arq-comp__t-channel__icon"
                                          />
                                        );
                                      }
                                    })()}

                                    {data_envio}
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        })()}

                        <div
                          className="anotc__mp-result-btn--recent"
                          onClick={(event) =>
                            this.ShowModals(
                              event,
                              "modal__agenda-pf__cliente__interacoes_history",
                              ContactId.telefone,
                              ContactId.idatendimento,
                              ContactId.cliente
                            )
                          }
                        >
                          Ver tudo
                        </div>
                      </div>
                    </li>

                    <ModalsDetails.InteractionsHistoricModal
                      IdContact={ContactId}
                      displayscreen={displayscreen}
                      monitorclient={monitorclient}
                    />

                    <li className="details__accordion-item details__accordion-anotc accordion-item">
                      <div
                        className={
                          this.state.buttonAnnotations
                            ? "details__accordion-top active"
                            : "details__accordion-top"
                        }
                        onClick={(event) =>
                          this.DisplayAnnotations(event, ContactId.telefone)
                        }
                      >
                        <Typography.H5 color={"blue-selected-4"} weight={700}>
                          Anotações
                        </Typography.H5>
                        {/* <p className="details__accordion-label">Anotações</p> */}
                        <span className="details__accordion-icon">
                          <ArrowDown className={`pausa-btn__icon-svg`} />
                          {/* <i className="material-icons">chevron_right</i> */}
                        </span>
                      </div>
                      <div className="details__accordion-item__content">
                        <div
                          className={
                            this.state.buttonAnnotations
                              ? "anotc__recent-content active"
                              : "anotc__recent-content"
                          }
                        >
                          {(() => {
                            if (this.state.detailsAnotations.length != 0) {
                              var cliente = createJSON(ContactId.cliente);
                              var nameC =
                                this.state.detailsAnotations[0]
                                  .usuario_anotacao;
                              var classe =
                                this.state.detailsAnotations[0]
                                  .class_criticality;
                              var criticidade =
                                this.state.detailsAnotations[0]
                                  .desc_criticidade;
                              var datahora =
                                this.state.detailsAnotations[0].data_anotacao +
                                " - " +
                                this.state.detailsAnotations[0].hora_anotacao;
                              var atendente =
                                this.state.detailsAnotations[0]
                                  .usuario_anotacao;
                              var texto =
                                this.state.detailsAnotations[0].desc_anotacao;
                              return (
                                <div>
                                  <div className="anotc__mp-result-item-top padding-bottom">
                                    <button className="anotc__mp-result-avatar anotc__mp-result-avatar--recent">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="10.06"
                                        height="11.807"
                                        viewBox="0 0 10.06 11.807"
                                      >
                                        <g transform="translate(0 0)">
                                          <ellipse
                                            cx="2.775"
                                            cy="2.738"
                                            rx="2.775"
                                            ry="2.738"
                                            transform="translate(2.255)"
                                            fill="#b7bec5"
                                          />
                                          <path
                                            d="M5.03,0A5,5,0,0,0,0,4.962H10.06A5,5,0,0,0,5.03,0Z"
                                            transform="translate(0 6.844)"
                                            fill="#b7bec5"
                                          />
                                        </g>
                                      </svg>
                                    </button>

                                    <div className="anotc__mp-result-item-info--recent">
                                      <p className="anotc__mp-result-item-name">
                                        {cliente}
                                      </p>
                                      <p className="anotc__mp-result-item-title">
                                        {nameC}
                                      </p>
                                    </div>
                                    <div className="anotc__mp-result-item-critic">
                                      <span
                                        className={
                                          "anotc__mp-result-item-level " +
                                          classe
                                        }
                                      >
                                        {criticidade}
                                      </span>
                                    </div>
                                  </div>

                                  <div className="anotc__mp-result-item-critic">
                                    <span className="anotc__mp-result-item-fulltime">
                                      {datahora}
                                    </span>
                                  </div>
                                  <div className="anotc__mp-result-item-content recent">
                                    {texto}
                                  </div>
                                </div>
                              );
                            }
                          })()}
                          <div
                            className="anotc__mp-result-btn--recent"
                            onClick={(event) =>
                              this.ShowModals(
                                event,
                                "modal__anotacoes-details",
                                ContactId.telefone,
                                ContactId.idatendimento,
                                ContactId.cliente
                              )
                            }
                          >
                            Ver tudo
                          </div>
                        </div>
                      </div>
                    </li>

                    {/* Modal De Anotacoes */}

                    <></>

                    <ModalsDetails.NewAnotationModal ContactId={ContactId} />

                    {/* Fim do Modal de Anotações */}

                    <li
                      className={
                        this.state.buttonSpotlight
                          ? "details__accordion-item accordion-item active"
                          : "details__accordion-item accordion-item"
                      }
                    >
                      <div
                        className={
                          this.state.buttonSpotlight
                            ? "details__accordion-top active"
                            : "details__accordion-top"
                        }
                        onClick={(event) =>
                          this.DisplaySpotlight(event, ContactId.telefone)
                        }
                      >
                        <Typography.H5 color={"blue-selected-4"} weight={700}>
                          Mensagens Favoritas
                        </Typography.H5>

                        <span className="details__accordion-icon">
                          {/* <i className="material-icons">chevron_right</i> */}
                          <ArrowDown className={`pausa-btn__icon-svg`} />
                        </span>
                      </div>
                      <div
                        className={
                          this.state.buttonSpotlight
                            ? "anotc__recent-content active"
                            : "anotc__recent-content"
                        }
                      >
                        {(() => {
                          if (this.state.detailsMarkstar2.length != 0) {
                            var cliente = createJSON(ContactId.cliente);
                            var mensagem =
                              this.state.detailsMarkstar2[0].mensagem;
                            var idmidia =
                              this.state.detailsMarkstar2[0].idmidia;
                            var data_envio =
                              this.state.detailsMarkstar2[0].data_markstar +
                              "-" +
                              this.state.detailsMarkstar2[0].data_markstar;
                            return (
                              <div>
                                <div className="msg-fav__mp-bubble recent">
                                  <div className=" msg-fav__mp-bubble--recent">
                                    {mensagem}
                                  </div>
                                  <span className="msg-fav__mp-star material-icons">
                                    star
                                  </span>
                                </div>
                                <div className="anotc__mp-result-item-top padding">
                                  <div className="anotc__mp-result-item-info--recent no-padding">
                                    <p className="anotc__mp-result-item-name small">
                                      {cliente}
                                    </p>
                                    {/* <p className="anotc__mp-result-item-title small">Atendente</p> */}
                                  </div>
                                  <div className="anotc__mp-result-item-critic med">
                                    {/* <img src="build/images/report/whatsapp_icon.png" width="15" alt="" /> */}
                                    {data_envio}
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        })()}

                        <div
                          className="anotc__mp-result-btn--recent"
                          onClick={(event) =>
                            this.ShowModals(
                              event,
                              "modal__mensagens-favoritas-details",
                              ContactId.telefone,
                              ContactId.idatendimento,
                              ContactId.cliente
                            )
                          }
                        >
                          Ver tudo
                        </div>
                      </div>
                    </li>

                    {/* Modal de Mensagens Favoritas */}

                    <ModalsDetails.NewMessageFavoriteModal
                      ContactId={ContactId}
                    />

                    <></>

                    {/* Fim do Modal Mensagens Favoritas */}
                    <li className="details__accordion-item accordion-item">
                      <div
                        className={
                          this.state.buttonFileComptd
                            ? "details__accordion-top active"
                            : "details__accordion-top"
                        }
                        onClick={(event) =>
                          this.DisplayFileComptd(event, ContactId.telefone)
                        }
                      >
                        <Typography.H5 color={"blue-selected-4"} weight={700}>
                          Arquivos compartilhados
                        </Typography.H5>
                        <span className="details__accordion-icon">
                          <ArrowDown className={`pausa-btn__icon-svg`} />
                        </span>
                      </div>
                      <div
                        className={
                          this.state.buttonFileComptd
                            ? "anotc__recent-content active"
                            : "anotc__recent-content"
                        }
                      >
                        {(() => {
                          if (this.state.detailsFileShared.length != 0) {
                            var cliente = createJSON(ContactId.cliente);
                            var nameC =
                              this.state.detailsFileShared[0].usuario_anotacao;
                            var formato =
                              this.state.detailsFileShared[0].formato;
                            var idmidia =
                              this.state.detailsFileShared[0].idmidia;
                            var data_envio =
                              this.state.detailsFileShared[0].data_envio;
                            var mensagem =
                              this.state.detailsFileShared[0].mensagem;
                            var tamanhourl = dbfileSize(
                              this.state.detailsFileShared[0].filesize
                            );
                            return (
                              <div>
                                <div className="anotc__mp-result-item-info--recent no-padding">
                                  <div className="anotc__mp-result-item-info--recent__header">
                                    <div className="arq-comp__t-sort">
                                      <span className="arq-comp__t-sort_ft">
                                        {formato}
                                      </span>
                                    </div>

                                    <div className="anotc__mp-result-item-info--recent__header__title">
                                      <p className="anotc__mp-result-item-name">
                                        {"Arquivo em " + formato}
                                      </p>
                                      <p className="anotc__mp-result-item-title">
                                        {tamanhourl}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="anotc__mp-result-item-info--recent__main">
                                  <div className="line">
                                    <p className="anotc__mp-result-item-info--recent__main__name">
                                      Data:
                                    </p>
                                    <p className="anotc__mp-result-item-info--recent__main__value">
                                      {data_envio}
                                    </p>
                                  </div>
                                  <div className="line">
                                    <p className="anotc__mp-result-item-info--recent__main__name">
                                      Canal:
                                      {(() => {
                                        if (idmidia === 5) {
                                          return (
                                            <img
                                              src={WHATSAPP}
                                              alt=""
                                              className="arq-comp__t-channel__icon"
                                            />
                                          );
                                        } else if (idmidia === 4) {
                                          return (
                                            <img
                                              src="build/images/t-facebook.svg"
                                              alt=""
                                              className="arq-comp__t-channel__icon"
                                            />
                                          );
                                        } else if (idmidia === 2) {
                                          return (
                                            <img
                                              src={WEBCHAT}
                                              alt=""
                                              className="arq-comp__t-channel__icon"
                                            />
                                          );
                                        } else if (idmidia === 11) {
                                          return (
                                            <img
                                              src={GOOGLEGBM}
                                              width={15}
                                              height={15}
                                              alt=""
                                              className="arq-comp__t-channel__icon"
                                            />
                                          );
                                        } else if (idmidia === 15) {
                                          return (
                                            <img
                                              src={TEAMS}
                                              width={15}
                                              height={15}
                                              alt=""
                                              className="arq-comp__t-channel__icon"
                                            />
                                          );
                                        }
                                      })()}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        })()}

                        <div
                          className="anotc__mp-result-btn--recent"
                          onClick={(event) =>
                            this.ShowModals(
                              event,
                              "modal__arquivos-compartilhados-details",
                              ContactId.telefone,
                              ContactId.idatendimento,
                              ContactId.cliente
                            )
                          }
                        >
                          Ver tudo
                        </div>
                      </div>
                    </li>

                    {/* Modal Arquivos Compartilhados */}

                    <ModalsDetails.NewFileShareModal ContactId={ContactId} />
                    <></>
                  </ul>
                </div>
                {/* Modal de Historico */}
                <div
                  className="modal micromodal-slide"
                  id="modal__historico-atendimento-details"
                  aria-hidden="true"
                  role="dialog"
                >
                  <div className="modal__overlay" tabIndex="-1">
                    <div
                      className="modal__container"
                      role="dialog"
                      aria-modal="true"
                      aria-labelledby="modal__historico-atendimento__title"
                    >
                      <header className="modal__header">
                        <h2
                          className="modal__title"
                          id="modal__historico-atendimento__title"
                        >
                          Interações
                        </h2>
                        <button
                          className="modal__close"
                          aria-label="Close modal"
                          data-micromodal-close
                        ></button>
                      </header>
                      <main
                        className="modal__content"
                        id="modal__historico-atendimento__content"
                      >
                        <div className="hist-atd__info">
                          <div className="hist-atd__info-items">
                            {(() => {
                              var mensagem_tratada = createJSON(
                                ContactId.cliente
                              );
                              return (
                                <p className="hist-atd__name  is-poppins">
                                  {mensagem_tratada}
                                </p>
                              );
                            })()}
                            <i className="material-icons hist-atd__icon">
                              question_answer
                            </i>{" "}
                            <span className="hist-atd__info-text">
                              Total de{" "}
                              <span className="hist-atd__counter">
                                {this.state.totalhistory}
                              </span>{" "}
                              interações&#x28;s&#x29;
                            </span>
                          </div>
                          {(() => {
                            if (InfoUsers.permdownload === true) {
                              return (
                                <div className="hist-atd__info-pdf">
                                  <a
                                    href="#"
                                    onClick={this.exportPDFWithMethod}
                                  >
                                    <img src={ICONPDFEXPORT} />
                                    Exportar PDF
                                  </a>
                                </div>
                              );
                            }
                          })()}
                        </div>
                        <div className="hist-atd__ctrls">
                          <p className="hist-atd__text">Período</p>
                          <span className="hist-atd__span">De:</span>
                          <input
                            type="datetime-local"
                            defaultValue={this.timedefaultinit}
                            ref={(input) => (this.datahistoryinit = input)}
                            className="hist-atd__end"
                            id="hist_start_queue"
                          />
                          <span className="hist-atd__span">Até:</span>
                          <input
                            type="datetime-local"
                            defaultValue={this.timedefaultfim}
                            ref={(input) => (this.datahistoryfim = input)}
                            className="hist-atd__end"
                            id="hist_end_queue"
                          />
                          <button
                            className="hist-atd__search-btn"
                            onClick={(event) =>
                              this.SearchHistory(
                                event,
                                ContactId.telefone,
                                ContactId.idatendimento
                              )
                            }
                          >
                            Filtrar
                          </button>
                        </div>
                        <div className="hist-atd__content">
                          <div
                            className={
                              this.state.showHistory
                                ? "hist-atd__search active"
                                : "hist-atd__search"
                            }
                          >
                            <span
                              onClick={(event) => this.handleKeyUp("less")}
                              className="material-icons hist-atd__search-icon"
                            >
                              expand_less
                            </span>
                            <span
                              onClick={(event) => this.handleKeyUp("more")}
                              className="material-icons hist-atd__search-icon"
                            >
                              expand_more
                            </span>
                            <input
                              onChange={(event) =>
                                this.setState({
                                  searchText: event.target.value,
                                  arrowterm: 0,
                                })
                              }
                              type="text"
                              className="hist-atd__search-input"
                              placeholder="Pesquisar..."
                            />
                            <button
                              onClick={this.SearchInHistory.bind(this)}
                              className="hist-atd__search-btn hist-atd__search-btn--two"
                            >
                              Concluir
                            </button>
                          </div>
                          <div className="hist-atd__channel-info">
                            <img
                              className="hist-atd__channel-info-icon"
                              style={{ display: "none" }}
                              src={WHATSAPP}
                              alt=""
                              width="20"
                              height="20"
                            />
                            <div className="hist-atd__channel-info-time">
                              Interações
                            </div>
                          </div>
                          <div
                            className="hist-atd__wrapper"
                            onScroll={this.handleScroll}
                          >
                            <div className="hist-atd__channel">
                              <div className="hist-atd__channel-chat active">
                                {this.state.history.map((history) => (
                                  <div
                                    key={history.messageid}
                                    className={
                                      history.agente === true
                                        ? "message right"
                                        : "message left"
                                    }
                                  >
                                    {(() => {
                                      dia = history.diaenvio;
                                      mes = history.mesenvio;
                                      ano = history.anoenvio;
                                      mes = meses.indexOf(mes);
                                      dia = dia + " de " + meses[mes - 1];
                                      if (
                                        ano < history.anoenvio ||
                                        ano > history.anoenvio
                                      )
                                        dia = dia + " de " + history.anoenvio;
                                      if (dia != auxdia) {
                                        dia = dia;
                                        auxdia = dia;
                                      } else {
                                        auxdia = dia;
                                        dia = "";
                                      }
                                    })()}
                                    <div className="time">{dia}</div>
                                    <div
                                      className="bubble"
                                      id={"details_" + history.messageid}
                                    >
                                      {(() => {
                                        if (history.replyid > 0) {
                                          var text = "";
                                          var array = [];
                                          var posit = "";
                                          checkreply = true;

                                          array = this.state.history.filter(
                                            (msg) =>
                                              parseInt(msg.messageid) ===
                                              parseInt(history.replyid)
                                          );
                                          if (array.length !== 0 && array) {
                                            posit = array[0].author;
                                            if (array[0].mimetypeid !== 1) {
                                              var url = array[0].messagem;
                                              url = url.substring(
                                                url.lastIndexOf(".") + 1
                                              );
                                              switch (url.toLowerCase()) {
                                                case "jpeg":
                                                case "png":
                                                case "jpg": {
                                                  return (
                                                    <a
                                                      href={
                                                        "#details_" +
                                                        history.replyid
                                                      }
                                                    >
                                                      <div className="reply-message active">
                                                        <div className="reply-message__name">
                                                          {posit === "Me"
                                                            ? "Você"
                                                            : createJSON(
                                                                this.state
                                                                  .cliente
                                                              )}
                                                        </div>
                                                        <div className="reply-message__text">
                                                          <img
                                                            src={FOTO}
                                                            alt=""
                                                            width="15"
                                                          />{" "}
                                                          Imagem
                                                        </div>
                                                      </div>
                                                    </a>
                                                  );
                                                }
                                                case "pdf":
                                                  return (
                                                    <a
                                                      href={
                                                        "#details_" +
                                                        history.replyid
                                                      }
                                                    >
                                                      <div className="reply-message active">
                                                        <div className="reply-message__name">
                                                          {posit === "Me"
                                                            ? "Você"
                                                            : createJSON(
                                                                this.state
                                                                  .cliente
                                                              )}
                                                        </div>
                                                        <div className="reply-message__text">
                                                          <img
                                                            src={DOC}
                                                            alt=""
                                                            width="15"
                                                          />{" "}
                                                          PDF
                                                        </div>
                                                      </div>
                                                    </a>
                                                  );
                                                case "xls":
                                                case "xlsx":
                                                case "xlsm":
                                                case "doc":
                                                case "docx":
                                                case "ppt":
                                                case "pptx": {
                                                  return (
                                                    <a
                                                      href={
                                                        "#details_" +
                                                        history.replyid
                                                      }
                                                    >
                                                      <div className="reply-message active">
                                                        <div className="reply-message__name">
                                                          {posit === "Me"
                                                            ? "Você"
                                                            : createJSON(
                                                                this.state
                                                                  .cliente
                                                              )}
                                                        </div>
                                                        <div className="reply-message__text">
                                                          <img
                                                            src={DOC}
                                                            alt=""
                                                            width="15"
                                                          />{" "}
                                                          DOC
                                                        </div>
                                                      </div>
                                                    </a>
                                                  );
                                                }
                                                case "wav":
                                                case "mp3":
                                                case "ogg":
                                                case "mpeg": {
                                                  return (
                                                    <a
                                                      href={
                                                        "#details_" +
                                                        history.replyid
                                                      }
                                                    >
                                                      <div className="reply-message active">
                                                        <div className="reply-message__name">
                                                          {posit === "Me"
                                                            ? "Você"
                                                            : createJSON(
                                                                this.state
                                                                  .cliente
                                                              )}
                                                        </div>
                                                        <div className="reply-message__text">
                                                          <img
                                                            src={AUDIO}
                                                            alt=""
                                                            width="12"
                                                          />{" "}
                                                          Áudio
                                                        </div>
                                                      </div>
                                                    </a>
                                                  );
                                                }
                                                case "mp4": {
                                                  return (
                                                    <a
                                                      href={
                                                        "#details_" +
                                                        history.replyid
                                                      }
                                                    >
                                                      <div className="reply-message active">
                                                        <div className="reply-message__name">
                                                          {posit === "Me"
                                                            ? "Você"
                                                            : createJSON(
                                                                this.state
                                                                  .cliente
                                                              )}
                                                        </div>
                                                        <div className="reply-message__text">
                                                          <img
                                                            src={VIDEO}
                                                            alt=""
                                                            width="15"
                                                          />{" "}
                                                          Vídeo
                                                        </div>
                                                      </div>
                                                    </a>
                                                  );
                                                }
                                              }
                                            } else {
                                              text = array[0].messagem;
                                              if (text.length > 200)
                                                text =
                                                  text.substr(0, 200) + "...";
                                              text = text.replace(/¿/gi, "\n");
                                              text = text.replace(
                                                /§/gi,
                                                "\r\n"
                                              );
                                              return (
                                                <a
                                                  href={
                                                    "#details_" +
                                                    history.replyid
                                                  }
                                                >
                                                  <div className="reply-message active">
                                                    <div className="reply-message__name">
                                                      {posit === "Me"
                                                        ? "Você"
                                                        : createJSON(
                                                            this.state.cliente
                                                          )}
                                                    </div>
                                                    <div className="reply-message__text">
                                                      {text}
                                                    </div>
                                                  </div>
                                                </a>
                                              );
                                            }
                                          }
                                        }
                                        //}
                                      })()}

                                      <div className="bubble-user-name">
                                        {checkreply === false
                                          ? history.agente === false
                                            ? createJSON(ContactId.cliente)
                                            : history.username
                                          : null}
                                      </div>
                                      <div className="text">
                                        {(() => {
                                          let caption = history.caption;
                                          if (
                                            caption == "null" ||
                                            caption == null
                                          ) {
                                            caption = "";
                                          } else {
                                            caption = caption.replace(
                                              /\\n/g,
                                              "\r\n"
                                            );
                                          }
                                          var positmessage1 = "";
                                          var positmessage2 = "";
                                          if (history.is_from_agent === true) {
                                            positmessage1 = " right";
                                          }
                                          checkreply = false;

                                          if (history.mimetypeid == "1") {
                                            var mensagem_tratada = tratarMSG(
                                              history.messagem
                                            );

                                            mensagem_tratada =
                                              mensagem_tratada.replace(
                                                /\\n/gi,
                                                "\r\n"
                                              );
                                            return (
                                              <>
                                                <div>
                                                  <Highlighter
                                                    highlightClassName="YourHighlightClass"
                                                    searchWords={searchWords}
                                                    autoEscape={true}
                                                    textToHighlight={
                                                      mensagem_tratada
                                                    }
                                                    sanitize={latinize}
                                                  />
                                                  <span className="text__end-spacing"></span>
                                                </div>
                                              </>
                                            );
                                          } else {
                                            if (history.mimetypeid == "2") {
                                              if (
                                                isJson(history.messagem) ===
                                                true
                                              ) {
                                                let json = JSON.parse(
                                                  history.messagem
                                                );
                                                let options = json.options;
                                                let i = 1;
                                                var opcoes = [];
                                                for (i in options) {
                                                  opcoes.push(
                                                    i + " - " + options[i][1]
                                                  );
                                                }
                                                return (
                                                  <div>
                                                    <Highlighter
                                                      highlightClassName="YourHighlightClass"
                                                      searchWords={searchWords}
                                                      autoEscape={true}
                                                      textToHighlight={
                                                        json.msg + " \r\n "
                                                      }
                                                      sanitize={latinize}
                                                    />
                                                    <Highlighter
                                                      highlightClassName="YourHighlightClass"
                                                      searchWords={searchWords}
                                                      autoEscape={true}
                                                      textToHighlight={opcoes.join(
                                                        "  \r\n  "
                                                      )}
                                                      sanitize={latinize}
                                                    />
                                                    <span className="text__end-spacing"></span>
                                                  </div>
                                                );
                                              } else {
                                                return (
                                                  <div>
                                                    <Highlighter
                                                      highlightClassName="YourHighlightClass"
                                                      searchWords={searchWords}
                                                      autoEscape={true}
                                                      textToHighlight={
                                                        history.messagem
                                                      }
                                                    />
                                                    <span className="text__end-spacing"></span>
                                                  </div>
                                                );
                                              }
                                            } else if (
                                              parseInt(history.mimetypeid) == 30
                                            ) {
                                              if (
                                                isJson(history.messagem) ===
                                                true
                                              ) {
                                                let json = JSON.parse(
                                                  history.messagem
                                                );
                                                let options = json.options;

                                                let i = 1;
                                                var opcoes = [];
                                                for (i in options) {
                                                  opcoes.push(
                                                    i + " - " + options[i][1]
                                                  );
                                                }
                                                if (json.MSG) {
                                                  return (
                                                    <div>
                                                      <Highlighter
                                                        highlightClassName="YourHighlightClass"
                                                        searchWords={
                                                          searchWords
                                                        }
                                                        autoEscape={true}
                                                        textToHighlight={
                                                          json.MSG + " \r\n "
                                                        }
                                                        sanitize={latinize}
                                                      />
                                                      <Highlighter
                                                        highlightClassName="YourHighlightClass"
                                                        searchWords={
                                                          searchWords
                                                        }
                                                        autoEscape={true}
                                                        textToHighlight={opcoes.join(
                                                          "  \r\n  "
                                                        )}
                                                        sanitize={latinize}
                                                      />
                                                      <span className="text__end-spacing"></span>
                                                    </div>
                                                  );
                                                } else if (json.URL) {
                                                  return (
                                                    <div>
                                                      <Highlighter
                                                        highlightClassName="YourHighlightClass"
                                                        searchWords={
                                                          searchWords
                                                        }
                                                        autoEscape={true}
                                                        textToHighlight={
                                                          json.URL + " \r\n "
                                                        }
                                                        sanitize={latinize}
                                                      />
                                                      <Highlighter
                                                        highlightClassName="YourHighlightClass"
                                                        searchWords={
                                                          searchWords
                                                        }
                                                        autoEscape={true}
                                                        textToHighlight={opcoes.join(
                                                          "  \r\n  "
                                                        )}
                                                        sanitize={latinize}
                                                      />
                                                      <span className="text__end-spacing"></span>
                                                    </div>
                                                  );
                                                }
                                              } else {
                                                return (
                                                  <div>
                                                    <Highlighter
                                                      highlightClassName="YourHighlightClass"
                                                      searchWords={searchWords}
                                                      autoEscape={true}
                                                      textToHighlight={
                                                        history.messagem
                                                      }
                                                    />
                                                    <span className="text__end-spacing"></span>
                                                  </div>
                                                );
                                              }
                                            } else if (
                                              history.mimetypeid == "3" ||
                                              history.mimetypeid == "4" ||
                                              history.mimetypeid == "5" ||
                                              history.mimetypeid >= "6"
                                            ) {
                                              let separador =
                                                history.messagem.split(".");
                                              switch (separador[1]) {
                                                case "jpeg":
                                                case "png":
                                                case "PNG":
                                                case "jpg":
                                                  return (
                                                    <div className="bubble-media">
                                                      <div
                                                        className="bubble-media__image"
                                                        onClick={(e) =>
                                                          this.VerifierImage(
                                                            e,
                                                            connection_platform.type_connect +
                                                              "://" +
                                                              ipcurrent +
                                                              history.messagem,
                                                            "history"
                                                          )
                                                        }
                                                      >
                                                        {this.state.isOpen && (
                                                          <Lightbox
                                                            mainSrc={
                                                              this.state
                                                                .urlimage
                                                            }
                                                            onCloseRequest={(
                                                              e
                                                            ) =>
                                                              this.CloseImage(
                                                                e,
                                                                "history"
                                                              )
                                                            }
                                                          />
                                                        )}
                                                        <img
                                                          src={
                                                            connection_platform.type_connect +
                                                            "://" +
                                                            ipcurrent +
                                                            history.messagem
                                                          }
                                                          alt=""
                                                        />
                                                      </div>
                                                      <div className="bubble-media__mediaInfo">
                                                        <span className="bubble-media__fileType">
                                                          <img
                                                            className="bubble-media__fileIcon"
                                                            src={JPG}
                                                            alt=""
                                                          />
                                                        </span>
                                                        <span className="bubble-media__fileName">
                                                          <p className="bubble-media__text">
                                                            Nome do Arquivo
                                                          </p>
                                                          <br />
                                                          <div className="fileinfo__bar">
                                                            <span className="fileinfo__size">
                                                              {dbfileSize(
                                                                history.filesize
                                                              )}
                                                            </span>{" "}
                                                            •{" "}
                                                            <span className="fileinfo__type">
                                                              {""}
                                                            </span>
                                                          </div>
                                                        </span>
                                                        {(() => {
                                                          if (
                                                            InfoUsers.permdownload ===
                                                            true
                                                          ) {
                                                            return (
                                                              <div className="bubble-media__download">
                                                                <a
                                                                  href={
                                                                    connection_platform.type_connect +
                                                                    "://" +
                                                                    ipcurrent +
                                                                    history.messagem
                                                                  }
                                                                  target="_blank"
                                                                  download
                                                                  className="bubble-media__btnDownload"
                                                                >
                                                                  <i className="material-icons">
                                                                    get_app
                                                                  </i>
                                                                </a>
                                                              </div>
                                                            );
                                                          }
                                                        })()}
                                                      </div>
                                                    </div>
                                                  );
                                                  break;
                                                case "pdf":
                                                  return (
                                                    <div className="bubble-media">
                                                      <div className="bubble-media__mediaInfo">
                                                        <span className="bubble-media__fileType">
                                                          <img
                                                            className="bubble-media__fileIcon"
                                                            src={PDF}
                                                            alt=""
                                                          />
                                                        </span>
                                                        <span className="bubble-media__fileName">
                                                          <p className="bubble-media__text">
                                                            Nome do Arquivo
                                                          </p>
                                                          <br />
                                                          <div className="fileinfo__bar">
                                                            <span className="fileinfo__size">
                                                              {dbfileSize(
                                                                history.filesize
                                                              )}
                                                            </span>{" "}
                                                            •{" "}
                                                            <span className="fileinfo__type">
                                                              {""}
                                                            </span>
                                                          </div>
                                                        </span>
                                                        {(() => {
                                                          if (
                                                            InfoUsers.permdownload ===
                                                            true
                                                          ) {
                                                            return (
                                                              <div className="bubble-media__download">
                                                                <a
                                                                  href={
                                                                    connection_platform.type_connect +
                                                                    "://" +
                                                                    ipcurrent +
                                                                    history.messagem
                                                                  }
                                                                  target="_blank"
                                                                  download
                                                                  className="bubble-media__btnDownload"
                                                                >
                                                                  <i className="material-icons">
                                                                    get_app
                                                                  </i>
                                                                </a>
                                                              </div>
                                                            );
                                                          }
                                                        })()}
                                                      </div>
                                                    </div>
                                                  );
                                                  break;
                                                case "xls":
                                                case "xlsx":
                                                case "xlsm":
                                                case "doc":
                                                case "docx":
                                                case "ppt":
                                                case "pptx":
                                                  return (
                                                    <div className="bubble-media">
                                                      <div className="bubble-media__mediaInfo">
                                                        <span className="bubble-media__fileType">
                                                          <img
                                                            className="bubble-media__fileIcon"
                                                            src={XLS}
                                                            alt=""
                                                          />
                                                        </span>
                                                        <span className="bubble-media__fileName">
                                                          <p className="bubble-media__text">
                                                            Nome do Arquivo
                                                          </p>
                                                          <br />
                                                          <div className="fileinfo__bar">
                                                            <span className="fileinfo__size">
                                                              {dbfileSize(
                                                                history.filesize
                                                              )}
                                                            </span>{" "}
                                                            •{" "}
                                                            <span className="fileinfo__type">
                                                              {""}
                                                            </span>
                                                          </div>
                                                        </span>
                                                        {(() => {
                                                          if (
                                                            InfoUsers.permdownload ===
                                                            true
                                                          ) {
                                                            return (
                                                              <div className="bubble-media__download">
                                                                <a
                                                                  href={
                                                                    connection_platform.type_connect +
                                                                    "://" +
                                                                    ipcurrent +
                                                                    history.messagem
                                                                  }
                                                                  target="_blank"
                                                                  download
                                                                  className="bubble-media__btnDownload"
                                                                >
                                                                  <i className="material-icons">
                                                                    get_app
                                                                  </i>
                                                                </a>
                                                              </div>
                                                            );
                                                          }
                                                        })()}
                                                      </div>
                                                    </div>
                                                  );
                                                  break;
                                                case "wav":
                                                case "mp3":
                                                case "ogg":
                                                case "mpeg":
                                                  return (
                                                    <div className="bubble-media">
                                                      <div className="bubble-media__playerBar">
                                                        <audio controls>
                                                          <source
                                                            src={
                                                              connection_platform.type_connect +
                                                              "://" +
                                                              ipcurrent +
                                                              history.messagem
                                                            }
                                                            type="audio/ogg"
                                                          />
                                                          <source
                                                            src={
                                                              connection_platform.type_connect +
                                                              "://" +
                                                              ipcurrent +
                                                              history.messagem
                                                            }
                                                            type="audio/mpeg"
                                                          />
                                                          Your browser.
                                                        </audio>
                                                      </div>
                                                      <div className="bubble-media__mediaInfo">
                                                        <span className="bubble-media__fileType">
                                                          <img
                                                            className="bubble-media__fileIcon"
                                                            src={MP3}
                                                            alt=""
                                                          />
                                                        </span>
                                                        <span className="bubble-media__fileName">
                                                          <p className="bubble-media__text">
                                                            Nome do Arquivo
                                                          </p>
                                                          <br />
                                                          <div className="fileinfo__bar">
                                                            <span className="fileinfo__size">
                                                              {dbfileSize(
                                                                history.filesize
                                                              )}
                                                            </span>{" "}
                                                            •{" "}
                                                            <span className="fileinfo__type">
                                                              {""}
                                                            </span>
                                                          </div>
                                                        </span>
                                                        {(() => {
                                                          if (
                                                            InfoUsers.permdownload ===
                                                            true
                                                          ) {
                                                            return (
                                                              <div className="bubble-media__download">
                                                                <a
                                                                  href={
                                                                    connection_platform.type_connect +
                                                                    "://" +
                                                                    ipcurrent +
                                                                    history.messagem
                                                                  }
                                                                  target="_blank"
                                                                  download
                                                                  className="bubble-media__btnDownload"
                                                                >
                                                                  <i className="material-icons">
                                                                    get_app
                                                                  </i>
                                                                </a>
                                                              </div>
                                                            );
                                                          }
                                                        })()}
                                                      </div>
                                                    </div>
                                                  );
                                                  break;
                                                case "mp4":
                                                  return (
                                                    <div className="bubble-media">
                                                      <div className="bubble-media__video">
                                                        <video
                                                          className="bubble-media__video-frame"
                                                          controls
                                                        >
                                                          <source
                                                            className="bubble-media__video-file"
                                                            src={
                                                              connection_platform.type_connect +
                                                              "://" +
                                                              ipcurrent +
                                                              history.messagem
                                                            }
                                                            type="video/mp4"
                                                          />
                                                          Seu navegador nao
                                                          suporta esse tipo de
                                                          arquivo.
                                                        </video>
                                                      </div>
                                                      <div className="bubble-media__mediaInfo">
                                                        <span className="bubble-media__fileType">
                                                          <img
                                                            className="bubble-media__fileIcon"
                                                            src={AVI}
                                                            alt=""
                                                          />
                                                        </span>
                                                        <span className="bubble-media__fileName">
                                                          <p className="bubble-media__text">
                                                            Nome do Arquivo
                                                          </p>
                                                          <br />
                                                          <div className="fileinfo__bar">
                                                            <span className="fileinfo__size">
                                                              {dbfileSize(
                                                                history.filesize
                                                              )}
                                                            </span>{" "}
                                                            •{" "}
                                                            <span className="fileinfo__type">
                                                              {""}
                                                            </span>
                                                          </div>
                                                        </span>
                                                        {(() => {
                                                          if (
                                                            InfoUsers.permdownload ===
                                                            true
                                                          ) {
                                                            return (
                                                              <div className="bubble-media__download">
                                                                <a
                                                                  href={
                                                                    connection_platform.type_connect +
                                                                    "://" +
                                                                    ipcurrent +
                                                                    history.messagem
                                                                  }
                                                                  target="_blank"
                                                                  download
                                                                  className="bubble-media__btnDownload"
                                                                >
                                                                  <i className="material-icons">
                                                                    get_app
                                                                  </i>
                                                                </a>
                                                              </div>
                                                            );
                                                          }
                                                        })()}
                                                      </div>
                                                    </div>
                                                  );
                                                  break;
                                                default:
                                              }
                                            }
                                          }
                                        })()}
                                      </div>
                                      <div className="text">
                                        {(() => {
                                          let caption = history.caption;
                                          if (
                                            caption == "null" ||
                                            caption == null
                                          ) {
                                            caption = "";
                                          } else {
                                            caption = caption.replace(
                                              /\\n/g,
                                              "\r\n"
                                            );
                                          }
                                          return caption;
                                        })()}
                                      </div>
                                      <div className="bubble__info-content">
                                        <div className="fav fav--inside fav--right"></div>
                                        <div className="bubble__info-content__time">
                                          {history.horaenvio}
                                        </div>

                                        {(() => {
                                          if (history.agente === true) {
                                            if (
                                              parseInt(history.mon_type_id) !==
                                              2
                                            ) {
                                              if (history.dateerror !== null)
                                                return (
                                                  <div
                                                    className={
                                                      "message-info message-info--error"
                                                    }
                                                  >
                                                    <i className="material-icons">
                                                      error
                                                    </i>
                                                  </div>
                                                );
                                              else if (
                                                history.dateread !== null
                                              )
                                                return (
                                                  <div
                                                    className={
                                                      "message-info message-info--visto"
                                                    }
                                                  >
                                                    <i className="material-icons">
                                                      done_all
                                                    </i>
                                                  </div>
                                                );
                                              else if (
                                                history.datedelivered !== null
                                              )
                                                return (
                                                  <div
                                                    className={"message-info"}
                                                  >
                                                    <i className="material-icons">
                                                      done_all
                                                    </i>
                                                  </div>
                                                );
                                              else
                                                return (
                                                  <div
                                                    className={"message-info"}
                                                  >
                                                    <i className="material-icons">
                                                      done
                                                    </i>
                                                  </div>
                                                );
                                            } else {
                                              return (
                                                <div
                                                  className={
                                                    "message-info message-info--visto"
                                                  }
                                                >
                                                  <i className="material-icons">
                                                    done_all
                                                  </i>
                                                </div>
                                              );
                                            }
                                          }
                                        })()}
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </main>

                      <button
                        className="hist-atd__fab"
                        onClick={this.SearchInHistory.bind(this)}
                      >
                        <i className="material-icons">search</i>
                      </button>
                    </div>
                  </div>
                </div>
                {/* Fim do Modal de Historico */}
              </div>

              {/* MODAL DE VINCULAR E ADICIONAR CONTATO */}
              <div
                className="modal micromodal-slide"
                id="modal__linkAdd-contact"
                aria-hidden="true"
                role="dialog"
              >
                <div className="modal__overlay" tabIndex="-1">
                  <div
                    className="modal__container"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="modal__linkAdd-contact__title"
                  >
                    <header className="modal__header">
                      <Typography.H2 color={"blue-selected-4"} weight={700}>
                        {this.state.typeModal === "link"
                          ? "Vincular contato"
                          : "Adicionar contato"}
                      </Typography.H2>
                      <button
                        className="modal__close"
                        aria-label="Close modal"
                        data-micromodal-close
                        onClick={(e) => this.CloseModal(this.state.typeModal)}
                      ></button>
                    </header>
                    <main
                      className="modal__content"
                      id="modal__linkAdd-contact__content"
                    >
                      {!DetailsContacts.detailsget &&
                        DetailsContacts.detailscontacts && (
                          <>
                            <Typography.H4 color={"gray-180"}>
                              Selecione o contato que você deseja vincular a
                              este número{" "}
                              {DetailsContacts.detailscontacts.telefone ||
                                DetailsContacts.detailscontacts.number}
                              .
                            </Typography.H4>

                            <FieldContainer title="Contato" required htmlFor="">
                              <div
                                className={
                                  this.state.viewContacts
                                    ? "select card--no-mg active"
                                    : "select card--no-mg"
                                }
                              >
                                <button
                                  className="select__btn"
                                  type="button"
                                  id="mult-filter-inside"
                                  onClick={() =>
                                    this.setState({
                                      viewContacts: !this.state.viewContacts,
                                    })
                                  }
                                >
                                  {this.state.linkContact
                                    ? this.state.linkContact.name
                                    : "Selecione..."}
                                  <i className="select__icon material-icons">
                                    keyboard_arrow_right
                                  </i>
                                </button>
                                <div className="options options--advanced">
                                  <div className="options--advanced__search-box">
                                    <div className="full-search">
                                      <input
                                        type="text"
                                        value={this.state.textSearchContacts}
                                        placeholder="Busca..."
                                        onChange={(event) => {
                                          this.setState({
                                            textSearchContacts:
                                              event.target.value,
                                          });
                                        }}
                                        onKeyDown={(event) => {
                                          if (event.keyCode === 13) {
                                            this.handleSearchContact(
                                              this.state.textSearchContacts,
                                              1
                                            );
                                          }
                                        }}
                                      />
                                      <button
                                        type="button"
                                        className="full-search__btn"
                                        onClick={() =>
                                          this.handleSearchContact(
                                            this.state.textSearchContacts,
                                            1
                                          )
                                        }
                                      >
                                        <i className="material-icons">search</i>
                                      </button>
                                    </div>
                                  </div>
                                  <div className="options--advanced__filter-box">
                                    <div className="options--advanced__filter-box__content">
                                      <ul className="checkbox checkbox__list">
                                        {this.state.listSearchContacts.map(
                                          (contact) => (
                                            <li
                                              className="checkbox__item"
                                              key={contact.id}
                                              onClick={() => {
                                                this.handleChooseLinkContact(
                                                  contact
                                                );
                                              }}
                                            >
                                              <label
                                                htmlFor={
                                                  "checkbox-service" +
                                                  contact.name
                                                }
                                              >
                                                {createJSON(contact.name)}
                                              </label>
                                              <label
                                                htmlFor={
                                                  "checkbox-service" +
                                                  contact.number
                                                }
                                              >
                                                {contact.number}
                                              </label>
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </FieldContainer>
                          </>
                        )}
                    </main>
                    <div className="modal-box__footer">
                      <button
                        className="button_cancel"
                        onClick={(e) => this.CloseModal(this.state.typeModal)}
                      >
                        <span>Cancelar</span>
                      </button>
                      <button
                        className="button_save"
                        onClick={(e) =>
                          this.handleSaveContact(
                            this.state.typeModal,
                            ContactId,
                            InfoUsers,
                            this.state.directDetails,
                            DetailsContacts
                          )
                        }
                      >
                        <span>Salvar</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          search={
            <Search
              children={
                <>
                  {/* MODAL DE VINCULAR E ADICIONAR CONTATO */}
                  <div
                    className="modal micromodal-slide"
                    id="modal__linkAdd-contact"
                    aria-hidden="true"
                    role="dialog"
                  >
                    <div className="modal__overlay" tabIndex="-1">
                      <div
                        className="modal__container"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="modal__linkAdd-contact__title"
                      >
                        <header className="modal__header">
                          <Typography.H2 color={"blue-selected-4"} weight={700}>
                            {this.state.typeModal === "link"
                              ? "Vincular contato"
                              : "Adicionar contato"}
                          </Typography.H2>
                          <button
                            className="modal__close"
                            aria-label="Close modal"
                            data-micromodal-close
                            onClick={(e) =>
                              this.CloseModal(this.state.typeModal)
                            }
                          ></button>
                        </header>
                        <main
                          className="modal__content"
                          id="modal__linkAdd-contact__content"
                        >
                          {!DetailsContacts.detailsget &&
                            DetailsContacts.detailscontacts && (
                              <>
                                <Typography.H4 color={"gray-180"}>
                                  Selecione o contato que você deseja vincular a
                                  este número{" "}
                                  {DetailsContacts.detailscontacts.telefone ||
                                    DetailsContacts.detailscontacts.number}
                                  .
                                </Typography.H4>

                                <FieldContainer
                                  title="Contato"
                                  required
                                  htmlFor=""
                                >
                                  <div
                                    className={
                                      this.state.viewContacts
                                        ? "select card--no-mg active"
                                        : "select card--no-mg"
                                    }
                                  >
                                    <button
                                      className="select__btn"
                                      type="button"
                                      id="mult-filter-inside"
                                      onClick={() =>
                                        this.setState({
                                          viewContacts:
                                            !this.state.viewContacts,
                                        })
                                      }
                                    >
                                      {this.state.linkContact
                                        ? this.state.linkContact.name
                                        : "Selecione..."}
                                      <i className="select__icon material-icons">
                                        keyboard_arrow_right
                                      </i>
                                    </button>
                                    <div className="options options--advanced">
                                      <div className="options--advanced__search-box">
                                        <div className="full-search">
                                          <input
                                            type="text"
                                            value={
                                              this.state.textSearchContacts
                                            }
                                            placeholder="Busca..."
                                            onChange={(event) => {
                                              this.setState({
                                                textSearchContacts:
                                                  event.target.value,
                                              });
                                            }}
                                            onKeyDown={(event) => {
                                              if (event.keyCode === 13) {
                                                this.handleSearchContact(
                                                  this.state.textSearchContacts,
                                                  1
                                                );
                                              }
                                            }}
                                          />
                                          <button
                                            type="button"
                                            className="full-search__btn"
                                            onClick={() =>
                                              this.handleSearchContact(
                                                this.state.textSearchContacts,
                                                1
                                              )
                                            }
                                          >
                                            <i className="material-icons">
                                              search
                                            </i>
                                          </button>
                                        </div>
                                      </div>
                                      <div className="options--advanced__filter-box">
                                        <div className="options--advanced__filter-box__content">
                                          <ul className="checkbox checkbox__list">
                                            {this.state.listSearchContacts.map(
                                              (contact) => (
                                                <li
                                                  className="checkbox__item"
                                                  key={contact.id}
                                                  onClick={() => {
                                                    this.handleChooseLinkContact(
                                                      contact
                                                    );
                                                  }}
                                                >
                                                  <label
                                                    htmlFor={
                                                      "checkbox-service" +
                                                      contact.name
                                                    }
                                                  >
                                                    {createJSON(contact.name)}
                                                  </label>
                                                  <label
                                                    htmlFor={
                                                      "checkbox-service" +
                                                      contact.number
                                                    }
                                                  >
                                                    {contact.number}
                                                  </label>
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </FieldContainer>
                              </>
                            )}
                        </main>
                        <div className="modal-box__footer">
                          <button
                            className="button_cancel"
                            onClick={(e) =>
                              this.CloseModal(this.state.typeModal)
                            }
                          >
                            <span>Cancelar</span>
                          </button>
                          <button
                            className="button_save"
                            onClick={(e) =>
                              this.handleSaveContact(
                                this.state.typeModal,
                                ContactId,
                                InfoUsers,
                                this.state.directDetails,
                                DetailsContacts
                              )
                            }
                          >
                            <span>Salvar</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              }
            />
          }
        />
      </>
    );
  }
  exportPDFWithMethod = () => {
    savePDF(ReactDOM.findDOMNode(this.pdfExportComponent), {
      paperSize: "A4",
      margin: 10,
      fileName: this.state.cliente + "_" + this.state.clientpdf + ".pdf",
    });
  };
  exportPDFWithComponent = () => {
    this.pdfExportComponent.save();
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailsAttendanceNps);
